const ModalTitle = ({ icon, tone, iconClass, title, subtitle }) => (
  <div className="ds-modal-title">
    {icon && (
      <div
        className={`ds-modal-title-icon ${
          iconClass || (tone ? `kpi-icon-${tone}` : "")
        }`}
      >
        {icon}
      </div>
    )}
    <div className="ds-modal-title-text">
      <span className="ds-modal-title-main">{title}</span>
      {subtitle && <span className="ds-modal-title-sub">{subtitle}</span>}
    </div>
  </div>
);

export default ModalTitle;
